import { gql } from 'graphql-request';

import {
  TaskID,
  TaskResultDownloadUrlsClassName,
  TaskResultDownloadUrlsID,
  TaskResultDownloadUrlsType,
  TaskResultDownloadUrlsUrl,
  TaskResultDownloadUrlsUUID,
  TaskUUID
} from '../tasksTypes';

export interface FetchTaskResultDownloadUrlsQueryResponse {
  id: TaskID;
  uuid: TaskUUID;
  resultDownloadUrls: {
    className: TaskResultDownloadUrlsClassName;
    url: TaskResultDownloadUrlsUrl;
    id: TaskResultDownloadUrlsID;
    uuid: TaskResultDownloadUrlsUUID;
    type: TaskResultDownloadUrlsType;
  }[];
}

export const FETCH_TASK_RESULT_DOWNLOAD_URLS_QUERY = gql`
  query TaskResultDownloadUrls($uuid: ID!) {
    task(uuid: $uuid) {
      id
      uuid
      resultDownloadUrls {
        className
        url
        id
        uuid
        type
      }
    }
  }
`;
